export const companyTypeEnum = {
  CLIENT: 'CLIENT',
  PARTNER: 'PARTNER',
} as const

export type CompanyTypeEnum = (typeof companyTypeEnum)[keyof typeof companyTypeEnum]

export type CompanyType = CompanyTypeEnum